// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect } from 'react';

import { type FeatureErrorKeyName, useEvolveGet } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = {
  opened: boolean;
  onClose: () => void;
  type:
    | {
        messageType: 'platformMessage';
        data: FeatureErrorKeyName;
      }
    | {
        messageType: 'plainText';
        data: string;
      };
};

const SALES_URL = 'https://evolvemep.com/contact-sales';

export const MissingFeatureModal = ({ type, opened, onClose }: Props) => {
  const { data, setDefaultOpts } = useEvolveGet(`admin/platformMessage`, {
    lazy: type.messageType === 'plainText',
    defaultConfig: { params: { keyName: type.data } },
  });

  useEffect(() => {
    setDefaultOpts({ lazy: type.messageType === 'plainText', defaultConfig: { params: { keyName: type.data } } });
  }, [setDefaultOpts, type.data, type.messageType]);

  const text =
    type.messageType === 'plainText'
      ? type.data
      : (data?.value ?? 'Feature not available. Please speak with our sales team for pricing.');

  return (
    <WrappedModal
      title="Feature requires a license"
      opened={opened}
      onClose={onClose}
      type="button"
      titleIcon="Info"
      titleIconColor="primary"
      cancellationText="Close"
      confirmationText="Contact sales"
      onConfirm={() => {
        window.open(SALES_URL, '_blank');
      }}
    >
      <Text>{text}</Text>
    </WrappedModal>
  );
};
